import { FC } from 'react';
import { ISupportCase } from '../../../shared';

interface Prop {
    supportCase?: ISupportCase;
}

export const SupportCaseTitle: FC<Prop> = ({ supportCase }) => {
    if (supportCase) {
        const { firstName, lastName } = supportCase.primarySupportee;
        const fullName = `${lastName || ''} ${firstName || ''}`.trim();
        return [supportCase.caseNumber, fullName, supportCase.externalId].filter(Boolean).join(' - ');
    }
};
